import Family from "../../../entities/Family/ui/Family";

const FamilyPage = () => {
    return (  
        <main>
            <Family/>
        </main>
    );
}
 
export default FamilyPage;